import { render, staticRenderFns } from "./TravelTransactionInfo.vue?vue&type=template&id=3806c75f&"
import script from "./TravelTransactionInfo.vue?vue&type=script&lang=js&"
export * from "./TravelTransactionInfo.vue?vue&type=script&lang=js&"
import style0 from "./TravelTransactionInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelTransactionInfo.vue"
export default component.exports